var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { loading } from '../../../elements/Loading';
import { Form } from '../../../components';
import { FieldType } from '../../../elements';
import { rules } from '../../../helpers/Validation';
var ExtrasForm = /** @class */ (function (_super) {
    __extends(ExtrasForm, _super);
    function ExtrasForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // taxes
        _this.taxes = _this.props.taxes ? _this.props.taxes : [];
        _this.taxesMapeados = _this.taxes.map(function (item) {
            return {
                value: String(item.id),
                name: item.name
            };
        });
        _this.taxesOptions = !_this.props.extra ? __spreadArray([{ value: '0', name: '' }], _this.taxesMapeados, true) : _this.taxesMapeados;
        _this.fields = [
            {
                name: 'name',
                type: FieldType.Text,
                rules: rules()
                    .string()
                    .required(),
                size: 4
            },
            {
                name: 'tax',
                column: 'tax_id',
                type: FieldType.Select,
                rules: rules()
                    .number()
                    .integer()
                    .required(),
                options: _this.taxesOptions,
                size: 2,
            },
            {
                name: 'price',
                type: FieldType.Number,
                rules: rules()
                    .number()
                    .required(),
                size: 2
            },
            {
                name: 'description',
                type: FieldType.Text,
                rules: rules()
                    .string()
                    .required(),
                size: 2
            }
        ];
        return _this;
    }
    ExtrasForm.prototype.render = function () {
        var extra = this.props.extra;
        var extraStore = this.props.store.extraStore;
        return (React.createElement(Form, { calculator: true, loading: ['post@extras', 'put@extras', 'patch@extras'], fields: this.fields, values: extra, store: extraStore, stores: this.props.store }));
    };
    ExtrasForm = __decorate([
        inject('store'),
        loading(function (props) { return [
            props.match.params.id ?
                props.store.extraStore.read(props.match.params.id)
                    .then(function (extra) { return ({ extra: extra }); })
                :
                    undefined,
            props.store.taxes.read().then(function (taxes) { return ({ taxes: taxes }); })
        ]; }),
        observer
    ], ExtrasForm);
    return ExtrasForm;
}(Component));
export default ExtrasForm;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Extras/containers/ExtrasForm.tsx
// module id = 1604
// module chunks = 0